import { FaRecycle } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { TbWorldSearch } from "react-icons/tb";

export const cards = [
  {
    id: 1,
    title: "Promovemos la cultura",
    text: "Creamos estampas con una identidad propia, inspirándonos en Mendoza.",
    icon: TbWorldSearch,
  },
  {
    id: 2,
    title: "Producimos con impacto",
    text: "Reutilizamos descartes textiles propios y de otras empresas transformándolos en accesorios.",
    icon: FaRecycle,
  },
  {
    id: 3,
    title: "Creamos con versatilidad",
    text: "Producimos prendas cómodas, adaptables y accesibles.",
    icon: FaPeopleGroup,
  },
];
